<div *ngIf="isLoading" class="loader-overlay" [@fadeInOut]>
  <div class="loader-container">
    <!-- Animated AI Icon/Spinner -->
    <div class="ai-spinner">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-core"></div>
    </div>

    <!-- Animated AI Particles (reduced for less noise) -->
    <div class="particles">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
    </div>

    <!-- Neural Network Nodes (reduced for less noise) -->
    <div class="neural-network">
      <div class="node node-1"></div>
      <div class="node node-2"></div>
      <div class="node node-3"></div>
      <div class="connection connection-1"></div>
      <div class="connection connection-2"></div>
    </div>

    <!-- Loading Text -->
    <div class="loading-text"></div>
  </div>
</div>

